import { render, staticRenderFns } from "./SecurityLocalization.vue?vue&type=template&id=0787d63c&lang=pug&"
import script from "./SecurityLocalization.vue?vue&type=script&lang=js&"
export * from "./SecurityLocalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports